function Options({ question, dispatch, answer }) {
  return (
    <div className="options">
      {question.options.map((option) => (
        <button key={option}>
          <span>{option}</span>{" "}
        </button>
      ))}
    </div>
  );
}

export default Options;
